var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-screen-container"},[_c('FadeTransitionComponent',[_c(_vm.getCurrentRoute,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }